import { MultiDimensionalMap } from '@cims-online/shared'
import {
  ByFdcApprovalGroupInput,
  ByFdcConcurrenceGroupInput,
  ByFdcConcurrenceLevelAndApprovalGroupInput,
  ByFdcConcurrenceLevelAndConcurrenceGroupInput,
} from 'schema'
import { WithLabelledRecipients } from '../../../../types'

export interface TwoDimensionalGroupFormItemsProps {
  onChange?: (value: TwoDimensionalGroupFormItemsValues) => void
  value?: TwoDimensionalGroupFormItemsValues
  /**
   * whether to render approval groups or concurrence groups
   *
   * this also affects the groupIds in {@link GroupMapValue} and {@link TwoDimensionalGroupMapValue}
   */
  group: 'Approval Group' | 'Concurrence Group'
}

interface ApprovalGroups {
  /**
   * returned when {@link TwoDimensionalGroupFormItemsProps.group} is `Approval Group`
   */
  type: 'approvalGroup'
  approvalGroups: ApprovalGroup[]
  /**
   * @see {@link MultiDimensionalMap}
   */
  approvalGroupConcurrenceLevels: ApprovalGroupConcurrenceLevel[]
}

export type ApprovalGroup = Pick<ByFdcApprovalGroupInput, 'approvalGroupId'> &
  WithLabelledRecipients
export type ApprovalGroupConcurrenceLevel = Pick<
  ByFdcConcurrenceLevelAndApprovalGroupInput,
  'approvalGroupId' | 'concurrenceLevelId'
> &
  WithLabelledRecipients

interface ConcurrenceGroups {
  /**
   * returned when {@link TwoDimensionalGroupFormItemsProps.group} is `Concurrence Group`
   */
  type: 'concurrenceGroup'
  concurrenceGroups: ConcurrenceGroup[]
  /**
   * @see {@link MultiDimensionalMap}
   */
  concurrenceGroupConcurrenceLevels: ConcurrenceGroupConcurrenceLevel[]
}

export type ConcurrenceGroup = Pick<
  ByFdcConcurrenceGroupInput,
  'concurrenceGroupId'
> &
  WithLabelledRecipients
export type ConcurrenceGroupConcurrenceLevel = Pick<
  ByFdcConcurrenceLevelAndConcurrenceGroupInput,
  'concurrenceGroupId' | 'concurrenceLevelId'
> &
  WithLabelledRecipients

export type TwoDimensionalGroupFormItemsValues =
  | ApprovalGroups
  | ConcurrenceGroups

export interface GroupLevel extends WithLabelledRecipients {
  groupId: string
  concurrenceLevelId: string
}
export type GroupLevelMap = MultiDimensionalMap<GroupLevel>
export function newGroupLevelMap() {
  return new MultiDimensionalMap<GroupLevel>(
    ({ groupId, concurrenceLevelId }) => `${groupId}_${concurrenceLevelId}`
  )
}
